var _rect, _path, _path2, _path3, _path4, _path5, _path6;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgMyReportIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    opacity: 0.3,
    width: 27.22,
    height: 27.22,
    rx: 4,
    fill: "#D28F3B"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.6104 21.1101C17.7525 21.1101 21.1104 17.7522 21.1104 13.6101C21.1104 9.46797 17.7525 6.11011 13.6104 6.11011C9.46822 6.11011 6.11035 9.46797 6.11035 13.6101C6.11035 17.7522 9.46822 21.1101 13.6104 21.1101Z",
    stroke: "#D28F3B",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14.8604 17.9851C14.8604 17.6536 14.992 17.3356 15.2265 17.1012C15.4609 16.8668 15.7788 16.7351 16.1104 16.7351C16.4419 16.7351 16.7598 16.8668 16.9942 17.1012C17.2287 17.3356 17.3604 17.6536 17.3604 17.9851",
    stroke: "#D28F3B",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M9.86035 17.9851C9.86035 17.6536 9.99205 17.3356 10.2265 17.1012C10.4609 16.8668 10.7788 16.7351 11.1104 16.7351C11.4419 16.7351 11.7598 16.8668 11.9942 17.1012C12.2287 17.3356 12.3604 17.6536 12.3604 17.9851",
    stroke: "#D28F3B",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M14.8604 21.0058V17.9851C14.8604 17.6536 14.7287 17.3356 14.4942 17.1012C14.2598 16.8668 13.9419 16.7351 13.6104 16.7351C13.2788 16.7351 12.9609 16.8668 12.7265 17.1012C12.492 17.3356 12.3604 17.6536 12.3604 17.9851V21.0058",
    stroke: "#D28F3B",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M17.3604 20.1071V17.3601L13.6104 9.23511L9.86035 17.3601V20.1073",
    stroke: "#D28F3B",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M11.8794 12.9851H15.3409",
    stroke: "#D28F3B",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMyReportIcon);
export default __webpack_public_path__ + "static/media/MyReportIcon.8411f908f32f9a81953ba2dbfe842d5b.svg";
export { ForwardRef as ReactComponent };